module.exports = __webpack_public_path__ + "static/media/portfolio-banner-info-img2.5064b586.png";